<template>
  <v-dialog
    v-model="dialogAutorizacao"
    transition="dialog-top-transition"
    fullscreen
    hide-overlay
  >
    <v-card class="autorizacao-top-bar">
      <v-toolbar dark color="#042333" height="56px">
        <v-btn icon dark @click="setDialogAutorizacao(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Workflow de compras</v-toolbar-title>
      </v-toolbar>
      <autorizacao />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from "vuex";
import autorizacao from "./Autorizacao";

export default {
  components: {
    autorizacao,
  },
  computed: {
    dialogAutorizacao: {
      get() {
        return this.$store.state.app.dialogAutorizacao;
      },
      set(val) {
        this.$store.commit("app/setDialogAutorizacao", val);
      },
    },
  },
  methods: {
    ...mapMutations("app", ["setDialogAutorizacao"]),
  },
};
</script>
